import { loadable } from '@wix/communities-forum-client-commons/dist/src/services/loadable';

export const DevPanel = loadable(() => import('./dev-panel'));
